'use strict';

/*
see dealer.site.cta.js
// available on instances:
enterZip() or beginSearch(zip)

 // Also available on instances:
 setMode('identity') (non-pma)
 setMode('pma') default
 setMode('mirai') mirai dealers only. Also modifies query. Go figure
*/

define('features/ctas/dealer.search.modal',[
  'jquery',
  'lib/util/zip',
  'lib/services/batws',
  'lib/paginator',
  'lib/transforms/dealer.tmpl.common',
  'txt!tmpl/dealer.search.modal.zip.hbs',
  'txt!tmpl/dealer.search.modal.hbs',
  'txt!tmpl/dealer.search.modal.results.hbs',
  'txt!tmpl/dealer.search.modal.footer.hbs',
  'lib/util/langFromUrl',
  'zipTools',
  'lib/util/tda.config',

  // side effect includes
  'Handlebars',
  'lib/helpers/toJSON',
  'lib/helpers/ifCond',
  'bootstrapModal'
], function (
  $,
  zip,
  batws,
  Paginator,
  xformDealersCommon,
  txtDealerSearchModalZip,
  txtDealerSearchModal,
  txtDealerSearchResults,
  txtDealerSearchFooter,
  langFromUrl,
  zipTools,
  tdaConfig
) {
  var __lang = langFromUrl();
  var __tmplDealerSearchModalZip = Handlebars.compile(txtDealerSearchModalZip);
  var __tmplDealerSearchModal = Handlebars.compile(txtDealerSearchModal);
  var __tmplDealerResults = Handlebars.compile(txtDealerSearchResults);
  var __tmplDealerFooter = Handlebars.compile(txtDealerSearchFooter);
  var __initialized = false;
  var __currZip = zip.getCookiedDefaultFallback();

  function __dealerQuery(opts) {
    var paginatorOpts = {
      query: {},
      dataField: 'dealerLocator',
      countField: 'dealerCount',
      xform: xformDealersCommon,
      pageSize: 5
    };
    return $.extend(paginatorOpts, opts);
  }

  function __sameTda(res) {
    if (res.records[0].tdaCode === tdaConfig.tda.code) {
      return true;
    }
    return false;
  }

  var __identityFilter = function () {
    return true;
  };

  var __pmaFilter = function (dealer) {
    return dealer.isPma;
  };

  var __miraiOnly = function (dealer) {
    return dealer.isMirai;
  };

  var dealerSearchModal = {
    setMode: function (mode) {
      this.mode = mode;
      if (mode === 'pma') {
        this.filter = __pmaFilter;
      } else if (mode === 'mirai') {
        // not just filter here, also need to modify the query. God damn it
        this.filter = __miraiOnly;
      } else {
        this.filter = __identityFilter;
      }
      // save the default mode, as we need to change it back on zip code change
      if (!this.startMode) {
        this.startMode = this.mode;
      }
    },

    resetMode: function () {
      this.setMode(this.startMode); // reset our mode to its OG mode when user begins edit zip
    },

    showLoader: function () {
      $('#dealer-search-modal .loader').show();
    },

    hideLoader: function () {
      $('#dealer-search-modal .loader').hide();
    },

    enterZip: function () {
      var self = this;
      var copy = {
        en: {
          title: 'Looking for a dealership?',
          body: 'To select a dealer in your area, please enter your ZIP code.',
          placeholder: 'Enter ZIP code',
          cta: 'Find'
        },

        es: {
          title: 'Buscando un concesionario?',
          body: 'Para seleccionar un distribuidor en su &#x00E1;rea, por favor, introduzca su c&#x00F3;digo postal.',
          placeholder: 'C&#x00F3;digo postal',
          cta: 'Buscar'
        },
      };

      $('#modal-output-node').html(__tmplDealerSearchModalZip(copy[__lang]));
      $('#dealer-search-modal-zip').modal('show');

      $('.js-dealers-zip', '#dealer-search-modal-zip').on('click', function () {
        self.checkZip();
      });
    },

    checkZip: function () {
      var self = this;
      var enteredZip = $('#find-a-dealer-search-value', '#dealer-search-modal-zip').val();

      if (zip.isZipFormatValid(enteredZip)) {
        $('#dealer-search-modal-zip').on('hidden.bs.modal', function () {
          self.beginSearch(enteredZip);
        });
        $('#dealer-search-modal-zip').modal('hide');
      } else {
        self.invalidZip($('#dealer-search-modal-zip'));
      }
    },

    invalidZip: function ($currentModal) {
      var self = this;
      $currentModal.on('hidden.bs.modal', function () {
        function finalCallback(resZip, tdaChanged) {
          if (tdaChanged) return;
          self.beginSearch(resZip);
        }
        zipTools.showInvalidZipModal(__currZip, __currZip, null, finalCallback, false, false, false);
      });
      $currentModal.modal('hide');
    },

    beginSearch: function (calcZip) {
      var self = this;
      if (!self.mode) {
        self.setMode('pma');
      }
      var query = __dealerQuery({
        query: {
          zipcode: calcZip,
          mirai: self.mode === 'mirai'
        }
      });
      // ensures we are showing at least a loading modal
      self.buildResultsModal(calcZip);
      self.paginator = new Paginator(batws.geo().search, query);
      self.paginator.next()
        .then(function (res) {
          // no records, consider it an invalide zip
          if (!res.records.length) {
            self.invalidZip($('#dealer-search-modal'));
            return;
          }
          if (__sameTda(res)) {
            self.showResults(res);
          } else {
            $('#dealer-search-modal').on('hidden.bs.modal', function () {
              var changeToZip = res.records[0].zipCode;
              zipTools.changeZip(__currZip, changeToZip, window.location.pathname, null, false, false, false, false);
            });
            $('#dealer-search-modal').modal('hide');
          }
        })
        .catch(function (err) { console.error('Visit Dealer CTA paginator error: ', err); }); // eslint-disable-line no-console
    },

    buildResultsModal: function (calcZip) {
      var headerTxt = {
        en: { title: 'Select Your Dealer' },
        es: { title: 'Elegir concesionario' }
      };
      $('#modal-output-node').html(__tmplDealerSearchModal({
        userZip: calcZip,
        headerTxt: headerTxt[__lang].title
      }));
      // IF TDA of first dealer is no good, do something else here.
      $('#dealer-search-modal').modal('show');
      this.showLoader();
    },

    viewAll: function (e) {
      e.preventDefault();
      this.setMode('all');
      this.showResults(this.paginator.pageData);
    },

    showResults: function (res) {
      var self = this;
      self.hideLoader();
      var dealerData = $.extend({}, res, {
        records: res.records.filter(self.filter)
      });
      // Better spot for copy
      var actionsFooter = {
        en: {
          title: 'View More Dealers',
          url: '#'
        },
        es: {
          title: 'Ver más concesionarios',
          url: '#'
        }
      };
      var dataCopy = {
        en: {
          miles: 'miles',
          next: 'Next',
          prev: 'Previous',
          of: 'of',
          noDealersTitle: 'No Dealers Found',
          noDealersCopy: 'Please <a href="#" class="js-search-restart">search again</a> using a different location.',
          btnText: 'Select'
        },
        es: {
          miles: 'millas',
          next: 'Siguiente',
          prev: 'Anterior',
          of: 'de',
          noDealersTitle: 'No encontramos concesionarios',
          noDealersCopy: 'Por favor <a href="#" class="js-search-restart">busca nuevamente</a> con otra dirección.',
          btnText: 'Elegir'
        }
      };

      // update results area
      $('#dealer-search-modal .body-copy')
        .html(__tmplDealerResults({
          dealerResults: dealerData,
          resultCopy: dataCopy[__lang]
        }));

      $('#dealer-search-modal .body-footer')
        .html(__tmplDealerFooter({
          page: dealerData,
          action: actionsFooter[__lang],
          pma: self.mode === 'pma',
          resultCopy: dataCopy[__lang]
        }));

      self.dealerEvents();
      // Only attach modalEvents if we haven't done so already
      if (!__initialized) {
        self.modalEvents();
      }
    },

    modalEvents: function () {
      var self = this;
      $('.js-dealers-all', '#dealer-search-modal').on('click', function (e) {
        self.viewAll(e);
      });

      $('.js-edit-zip', '#dealer-search-modal').on('click', function (e) {
        e.preventDefault();
        self.editZip();
      });

      $('#dealer-search-modal').on('hidden.bs.modal', function () {
        __initialized = false;
      });

      __initialized = true;
    },

    dealerEvents: function () {
      var self = this;
      // Click event on actual Dealer Selection. Needs to be provided
      // via dealerSelect func on instance
      $('.dealer-action a', '#dealer-search-modal').on('click', function (e) {
        $('#dealer-search-modal').modal('hide');
        // always provide the selected dealer back
        var clickedDealer = $(this).data('dealercode');
        var selectedDealer = self.paginator.pageData.records.find(function (dealer) {
          return dealer.dealerCode == clickedDealer; // eslint-disable-line eqeqeq
        });
        self.dealerSelect(e, selectedDealer);
      });

      $('.js-page-prev', '#dealer-search-modal').on('click', function (e) {
        e.preventDefault();
        self.prevPage();
      });

      $('.js-page-next', '#dealer-search-modal').on('click', function (e) {
        e.preventDefault();
        self.nextPage();
      });
    },

    nextPage: function () {
      var self = this;
      if (self.paginator.hasNext()) {
        self.showLoader();
        self.paginator.next()
          .then(function (res) {
            self.showResults(res);
          })
          .catch(function (err) { console.error('Paginator next error: ', err); }); // eslint-disable-line no-console
      }
    },

    prevPage: function () {
      if (this.paginator.hasPrev()) {
        this.showResults(this.paginator.prev());
      }
    },

    editZip: function () {
      var self = this;
      self.resetMode();
      $('#dealer-search-modal').on('hidden.bs.modal', function () {
        self.enterZip();
      });
      $('#dealer-search-modal').modal('hide');
    }
  };

  return dealerSearchModal;
});

